import { i18n } from '../../i18n/translate';
import type { MenuEnvironment, MenuItem, MenuPermission } from './types';

export const homeroomTeacherLeft = (environment: MenuEnvironment): MenuItem => {
  const createMenuItem = (
    title: string,
    icon: string,
    path: string,
    permissions?: MenuPermission[],
    css_class: string = ''
  ): MenuItem => ({
    id: '',
    slug: '',
    title: i18n.t(title),
    icon,
    css_class,
    permissions,
    target_url: `${environment.MENU_DOMAIN_FOR_FRONT_END}${path}`,
    target_method: '',
    new_window: false,
    subsection: false,
    submenu_items: [],
    weight: 100,
  });

  return {
    id: 'foundry--universal_navigation--menus--homeroom_teacher_left',
    type: 'menus',
    slug: 'foundry--universal_navigation--menus--homeroom_teacher_left',
    title: '',
    icon: '',
    font_family: '',
    css_class: '',
    target_url: '',
    target_method: '',
    new_window: false,
    permissions: [{ has_permission: ['Users::K12Teacher'] }],
    subsection: false,
    submenu_items: [
      createMenuItem('Explore Courses', 'books', '/teacher/explore_courses'),
      createMenuItem('My Classes', 'chalkboard', '/teacher/my_classes'),
      createMenuItem('My Students', 'screen-users', '/teacher/my_students'),
      createMenuItem('Gradebook', 'notebook', '/teacher/gradebook'),
      createMenuItem('Opportunities', 'circle-star', '/teacher/opportunities', undefined, 'nav-separator'),
      createMenuItem('Guest Speakers', 'calendar-circle-plus', '/teacher/guest_speakers', [
        { k12_visit_requestable: true },
      ]),
      createMenuItem('Refer a Colleague', 'paper-plane', '/teacher/invite_a_teacher'),
    ],
  };
};
